/**
 * Layout Templates
 *
 * Predefined widget arrangements that can be used as starting points
 * when creating a new layout tab. Templates are static configuration —
 * once a tab is created from a template, the user can modify it freely
 * without affecting the original template.
 */

export interface LayoutTemplate {
  name: string;
  description: string;
  widgets: Array<{
    widgetType: string;
    x: number;
    y: number;
    w: number;
    h: number;
  }>;
}

export const LAYOUT_TEMPLATES: LayoutTemplate[] = [
  {
    name: 'Paper Trade',
    description: 'Option Monitor + Stock Monitor + Order Blotter',
    widgets: [
      { widgetType: 'option-monitor', x: 0, y: 0, w: 6, h: 20 },
      { widgetType: 'stock-monitor', x: 6, y: 0, w: 6, h: 10 },
      { widgetType: 'order-blotter', x: 6, y: 10, w: 6, h: 10 },
    ],
  },
  {
    name: 'Portfolio Monitor',
    description: 'Positions + Strategy Positions + Backtests',
    widgets: [
      { widgetType: 'positions', x: 0, y: 0, w: 12, h: 8 },
      { widgetType: 'strategy-positions', x: 0, y: 8, w: 6, h: 12 },
      { widgetType: 'backtests', x: 6, y: 8, w: 6, h: 12 },
    ],
  },
];
